import ChargeTypesService from "./chargeTypesService";
import ChargeOrderItem from "models/chargeOrderItem";
import ChargeOrder from "models/chargeOrder";

export default class PriceService {
  constructor(private chargeTypeService: ChargeTypesService) {}

  chargePrice = (chargeTypeId?: string, fuelType?: string) =>
    this.chargeTypeService?.chargePriceList?.items.find(
      item => item.chargeTypeId === chargeTypeId && item.fuelTypeId === fuelType
    )?.price || 0;

  chargeOrderItemTotal = (item: ChargeOrderItem) =>
    this.chargePrice(item.chargeTypeId as string, item.fuelTypeId as string) *
    (item.licensePlates?.length || (item.licensePlate ? 1 : 0));

  grandTotal(chargeOrder: ChargeOrder) {
    return chargeOrder.charges?.reduce((summary, chargeOrder) => summary + this.chargeOrderItemTotal(chargeOrder), 0) || 0;
  }
}
